import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";
import toSeoUrl from "@functions/toSeoUrl";

const fetchBannerCarousel = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/media/banner-carousel/${subscriberGroupId}`);
    const bannerCarousel = res.data?.data?.bannerCarousel ?? [];
    return bannerCarousel.map((film) => ({
        ...film,
        feature_url: film.feature_film_flag
            ? film.bo_movie_title
                ? `${film.ad_category_url}/${film.bo_movie_id}/${toSeoUrl(film.bo_movie_title)}`
                : `${film.ad_category_url}/${film.bo_movie_id}`
            : film.ad_category_url,
        trailer_url: film.trailer_available ? film.trailer_url : "",
    }));
};

export const useBannerCarousel = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["bannerCarousel", subscriberGroupId],
        queryFn: () => fetchBannerCarousel(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        carouselImages: data ?? null,
        isLoading,
    };
};
